/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicSecureScoresConfiguration extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicSecureScoresConfiguration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicSecureScoresConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicSecureScoresConfiguration>): BackgroundJobPayloadForPeriodicSecureScoresConfiguration {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicSecureScoresConfiguration(), model);
        BackgroundJobPayloadForPeriodicSecureScoresConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicSecureScoresConfiguration>): BackgroundJobPayloadForPeriodicSecureScoresConfiguration {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicSecureScoresConfiguration.newInstance(<BackgroundJobPayloadForPeriodicSecureScoresConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicSecureScoresConfiguration) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicSecureScoresConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicSecureScoresConfiguration): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicSecureScoresConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
